
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface FAQ {
  id: string;
  question: string;
  answer: string;
  category: string;
  views: number;
  helpful_count: number;
}

interface FAQAccordionProps {
  faq: FAQ;
  isOpen: boolean;
  onToggle: () => void;
  onHelpful: (id: string) => void;
  helpfulIds: string[];
}

export default function FAQAccordion({ faq, isOpen, onToggle, onHelpful, helpfulIds }: FAQAccordionProps) {
  const hasVoted = helpfulIds.includes(faq.id);

  return (
    <div className="bg-white rounded-xl border border-neutral-200 overflow-hidden shadow-soft hover:shadow-hover transition-shadow">
      <button
        onClick={onToggle}
        className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer group"
      >
        <span className="text-base font-semibold text-neutral-800 pr-4 group-hover:text-primary transition-colors">
          {faq.question}
        </span>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
          className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-primary/10 text-primary"
        >
          <i className="ri-arrow-down-s-line text-xl"></i>
        </motion.div>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            <div className="px-6 pb-5">
              <div className="pt-2 border-t border-neutral-100">
                <p className="text-neutral-600 text-sm leading-relaxed mt-4 whitespace-pre-line">
                  {faq.answer}
                </p>

                {/* Feedback */}
                <div className="mt-6 pt-4 border-t border-neutral-100 flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <span className="text-sm text-neutral-500">Esta resposta foi útil?</span>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!hasVoted) onHelpful(faq.id);
                      }}
                      disabled={hasVoted}
                      className={`flex items-center space-x-1.5 px-3 py-1.5 rounded-lg transition-all cursor-pointer ${
                        hasVoted
                          ? 'bg-green-100 text-green-600'
                          : 'bg-neutral-100 text-neutral-600 hover:bg-green-100 hover:text-green-600'
                      }`}
                    >
                      <i className={`ri-thumb-up-${hasVoted ? 'fill' : 'line'} text-sm`}></i>
                      <span className="text-sm font-medium">{faq.helpful_count + (hasVoted ? 1 : 0)}</span>
                    </button>
                  </div>
                  <div className="flex items-center space-x-1 text-neutral-400 text-xs">
                    <i className="ri-eye-line"></i>
                    <span>{faq.views} visualizações</span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
